<template>
  <div class="main_div">
    <section id="container" class="gnb_pdt">
      <div class="title_wrap">
        <h1>사용자 등록</h1>
      </div>
      <div class="contents_wrap w100">
        <div class="small_title_wrap">
          <h2>사용자 정보</h2>
        </div>
        <ul class="filter_list">
          <li>
            <dd>
              <label>ID<span class="forg">*</span></label>
              <ul>
                <li>
                  <kendo-maskedtextbox
                    :class="{'error' : errorTarget === 'userId'}"
                    ref="userIdRef"
                    @change="resetDuplicateCheck"
                    :style="'width: 79%; margin-right:1%'"
                    maxlength="20"
                    :placeholder="'사용자 ID를 입력하세요.'">
                  </kendo-maskedtextbox>
                  <button
                      class="mid_btn w20"
                      :class="{'error' : errorTarget === 'idDuplicateCheck'}"
                      :disabled="idDuplicateCheck === true"
                      @click="onClickIdDuplicateCheck">
                    중복확인
                  </button>
                </li>
              </ul>
            </dd>
            <dd>
              <label>성명<span class="forg">*</span></label>
              <ul>
                <li>
                  <kendo-maskedtextbox
                    :class="{'error' : errorTarget === 'userNm'}"
                    ref="userNmRef"
                    :style="'width: 100%;'"
                    maxlength="20"
                    :placeholder="'사용자명을 입력하세요.'">
                  </kendo-maskedtextbox>
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>소속 회사<span class="forg">*</span></label>
              <ul>
                <li>
                  <multi-dropdown-company
                      :class="{'error' : errorTarget === 'cmpyId'}"
                      ref="companyMultiDropdownRef"
                      @changeCmpyId="onChangeCmpyId"
                  >
                  </multi-dropdown-company>
                </li>
              </ul>
            </dd>
            <dd>
              <label>권한<span class="forg">*</span></label>
              <ul class="w80">
                <div v-for="item in authNmData">
                  <input
                      class="k-radio w100"
                      type="radio"
                      ref="authIdRef"
                      name="authIdRef"
                      v-model="authId"
                      :value="item.authId"
                      :id="`${item.authId}_status`"
                      @change="onChangeAuthId"
                  >
                  <label :for="`${item.authId}_status`" class="k-radio-label" style="width:125px">{{ item.authNm }} </label>
                </div>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>
                사업장/거점<span v-if="authId !== '9999'" class="forg">*</span>
              </label>
              <ul class="w50">
                <li>
                  <div class="box_flex">
                    <kendo-dropdownlist
                        class="w50"
                        :class="{'error' : errorTarget === 'facilityId'}"
                        ref="facilityRef"
                        :option-label="'사업장을 선택해주세요.'"
                        :data-source="zone1DepthListForAll"
                        :data-text-field="'cdNm'"
                        :data-value-field="'cdId'"
                        @change="onChangeFacility()"
                    >
                    </kendo-dropdownlist>
                    <kendo-dropdownlist
                        class="w50 mgl5"
                        :class="{'error' : errorTarget === 'areaId'}"
                        ref="areaRef"
                        :option-label="'사업장 선택 후 선택해주세요'"
                        :data-text-field="'cdNm'"
                        :data-value-field="'cdId'"
                        :index="0"
                    >
                    </kendo-dropdownlist>
                  </div>
                </li>
              </ul>
            </dd>
            <dd>
              <label>카드 No.<span v-if="authId === '1001'" class="forg">*</span></label>
              <ul>
                <li>
                  <kendo-maskedtextbox
                      :class="{'error' : errorTarget === 's1EmpNo'}"
                      ref="s1EmpNoRef"
                      :style="'width: 100%;'"
                      maxlength="20"
                      :placeholder="'카드 No.를 입력하세요.'"
                      :disabled="authId !== '1001'"
                  >
                  </kendo-maskedtextbox>
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>휴대전화번호<span class="forg">*</span></label>
              <ul>
                <li>
                  <kendo-maskedtextbox
                      ref="spTelNoRef"
                      :class="{'error' : errorTarget === 'spTelNo'}"
                      mask="000-0000-0000"
                      :style="'width: 100%;'"
                      maxlength="20"
                      :placeholder="'휴대전화번호를 입력하세요.'">
                  </kendo-maskedtextbox>
                </li>
              </ul>
            </dd>
            <dd>
              <label>이메일 주소<span class="forg">*</span></label>
              <ul>
                <li>
                  <kendo-maskedtextbox
                      ref="emailRef"
                      :class="{'error' : errorTarget === 'email'}"
                      :style="'width: 100%;'"
                      maxlength="50"
                      :placeholder="'이메일을 입력하세요.'">
                  </kendo-maskedtextbox>
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>계정 상태<span class="forg">*</span></label>
              <ul style="display: flex; justify-content:space-between;">
                <div v-for="item in userStatusList">
                  <input
                      class="k-radio"
                      type="radio"
                      ref="useYnRef"
                      name="useYnRef"
                      v-model="useYn"
                      :value="item.cdId"
                      :id="`${item.cdId}_status`"
                  >
                  <label :for="`${item.cdId}_status`" class="k-radio-label" style="width:100%;">{{ item.cdNm }} </label>
                </div>
              </ul>
            </dd>
            <dd>
              <label>IP 접근 제어 설정<span class="forg">*</span></label>
              <ul>
                <li :style="{display:'flex', gap:'12px', lineHeight:'1.9', paddingTop:'6px', alignItems: (ipPolicyYn === 'Y' && allowIpList.length >= 2) ? 'flex-start' : 'center'}">
                  <span class="mr10" :class="ipPolicyYn === 'Y' ? 'org' : ''">
                    {{ ipPolicyYn }}
                  </span>
                  <span
                      v-if="ipPolicyYn === 'Y' && allowIpList.length > 0"
                      class="ip-grid">
                    <template v-for="(item, idx) in allowIpList">
                      <span :key="'ip' + idx" class="ip-addr">{{ item.ipAddress }}/{{ item.cidrPrefix }}</span>
                      <span :key="'dt' + idx" class="ip-date">{{ item.lastMdfyDt }}</span>
                    </template>
                  </span>
                  <button
                      class="mid_btn w15"
                      style="align-self:center;"
                      @click="openIpSettings">
                    설정
                  </button>
                </li>
              </ul>
            </dd>
          </li>
        </ul>
      </div>
      <div class="fl button_area w100">
        <ul>
          <li class="w10"><button class="large_btn orange" @click="onClickSaveUser">등록</button></li>
          <li class="w10"> <button class="large_btn" @click="onClickList">목록</button></li>
        </ul>
      </div>

      <!-- IP 접근 제어 설정 팝업 -->
      <ip-access-control-window
          ref="ipSettingsWindowRef"
          :ip-policy-yn="ipPolicyYn"
          :allow-ip-list="allowIpList"
          :max-ip-count="maxIpCount"
          @apply="onApplyIpSettings">
      </ip-access-control-window>
    </section>
  </div>
</template>

<script>
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'
import EtnersCommonUtil from '@/common/etners.common.util'
import EtnersKendoGridUtil from '@/common/kendo.grid.util'
import MultiDropdownCompany from '@/components/MultiDropdownCompany'
import IpAccessControlWindow from '@/components/user/IpAccessControlWindow'
import $ from 'jquery'
import { LogisticsCodeDtlMixin, ZoneMixin } from '@/mixin/Mixin'
import EtnersLogisticsUtil from '@/common/etners.logistics.util'

export default {
  name: 'UserSave',
  components: {
    MultiDropdownCompany,
    IpAccessControlWindow,
  },
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  mounted() {
    const vm = this
    if(vm.userStatusList.length >= 4){
      vm.userStatusList = vm.userStatusList.splice(1) // '전체' 제거
    }
  },
  methods: {
    resetDuplicateCheck: function () {
      const vm = this
      vm.idDuplicateCheck = false
      vm.idDuplicateId = ''
    },

    onClickIdDuplicateCheck() {
      const vm = this

      vm.resetDuplicateCheck()
      vm.idDuplicateId = vm.$refs.userIdRef.kendoWidget().value()

      if (vm.idDuplicateId.trim() === '') {
        kendo.alert('ID를 입력해주세요.')
        vm.errorTarget = 'userId'
        return false
      }
      vm.errorTarget = null

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/user/duplicatedIdChk.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        userId: vm.idDuplicateId.trim(),
      }

      ApiUtil.post(url, param).then(response => {
        if(response.data === undefined || response.data.resultStatus === undefined){
          kendo.alert('정상적으로 처리되지 않았습니다.')
          return false
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          return false
        }
        vm.idDuplicateCheck = true
        kendo.alert('등록 가능한 ID입니다.')
      })
    },

    onChangeCmpyId (cmpyId) {
      const vm = this
      let select = []
      vm.authId = ''
      const arr = vm.authByCmpy.filter(v => v.cmpyId === cmpyId) // 회사 필터
      if(arr.length > 0 && vm.authNmData.length > 0) {
        for(let i=0; i<vm.authNmData.length; i++) { // 권한 리스트 사이즈만큼 for
          let id = `${vm.authNmData[i].authId}_status`
          if(arr[0].authId.includes(vm.authNmData[i].authId)) { // 필터링된 회사의 권한 리스트와 비교
            select.push(vm.authNmData[i].authId)
            document.getElementById(id).removeAttribute("disabled")
          } else {
            document.getElementById(id).setAttribute("disabled","disabled")
          }
        }
        if(select.length <= 1) { // 회사의 권한이 한개면 자동으로 select
          vm.authId = select[0]
        }
      }
    },
    onChangeAuthId () {
      const vm = this
      console.log('onchangeAuthId')
      if(vm.authId !== '1001'){
        vm.$refs.s1EmpNoRef.kendoWidget().value('')
      }
    },

    onClickSaveUser () {
      const vm = this
      const refs = vm.$refs
      const cmpyId =  vm.$refs.companyMultiDropdownRef.$refs.cmpyNmRef.kendoWidget().value()
      const facilityId = refs.facilityRef.kendoWidget().value().trim()
      const areaId = refs.areaRef.kendoWidget().value().trim()
      const userId = refs.userIdRef.kendoWidget().value().trim()
      const authId = vm.authId
      const userNm = refs.userNmRef.kendoWidget().value().trim()
      const s1EmpNo = refs.s1EmpNoRef.kendoWidget().value().trim()
      const spTelNo = refs.spTelNoRef.kendoWidget().value().trim()
      const email = refs.emailRef.kendoWidget().value().trim()
      const useYn = vm.useYn

      if (!vm.idDuplicateCheck) {
        kendo.alert('ID 중복체크를 해주세요.')
        vm.errorTarget = 'idDuplicateCheck'
        return false
      }
      if(EtnersCommonUtil.isEmpty(userId)){
        kendo.alert("사용자 ID를 입력해주세요.")
        vm.errorTarget = 'userId'
        return
      }
      if(EtnersCommonUtil.isEmpty(userNm)){
        kendo.alert("사용자명을 입력해주세요.")
        vm.errorTarget = 'userNm'
        return
      }
      if(EtnersCommonUtil.isEmpty(cmpyId)){
        kendo.alert("회사를 선택해주세요.")
        vm.errorTarget = 'cmpyId'
        return
      }
      if(EtnersCommonUtil.isEmpty(authId)){
        kendo.alert("권한을 선택해주세요.")
        vm.errorTarget = null
        return
      }
      if(authId !== '9999' && EtnersCommonUtil.isEmpty(facilityId)){
        kendo.alert("사업장을 선택해주세요.")
        vm.errorTarget = 'facilityId'
        return
      }
      if(authId !== '9999' && EtnersCommonUtil.isEmpty(areaId)){
        kendo.alert("거점을 선택해주세요.")
        vm.errorTarget = 'areaId'
        return
      }
      if(authId === '1001' && EtnersCommonUtil.isEmpty(s1EmpNo)){
        kendo.alert("카드 No. 를 입력해주세요.")
        vm.errorTarget = 's1EmpNo'
        return
      }
      if(EtnersCommonUtil.isEmpty(spTelNo)){
        kendo.alert("휴대전화번호를 입력해주세요.")
        vm.errorTarget = 'spTelNo'
        return
      } else if (!EtnersLogisticsUtil.isTelNum(spTelNo)){
        kendo.alert("휴대전화번호를 형식에 맞게 입력해 주세요.")
        vm.errorTarget = 'spTelNo'
        return
      }
      if(EtnersCommonUtil.isEmpty(email)){
        kendo.alert("이메일을 입력해주세요.")
        vm.errorTarget = 'email'
        return
      } else if(!EtnersCommonUtil.isEmailAddr(email)){
        kendo.alert('이메일 형식을 확인해주세요.')
        vm.errorTarget = 'email'
        return
      }
      if(EtnersCommonUtil.isEmpty(useYn)){
        kendo.alert("계정 상태를 선택해주세요.")
        vm.errorTarget = null
        return
      }
      // IP 정책 적용 시 허용 IP 1개 이상 필수 (잠금 계정 생성 방지)
      if(vm.ipPolicyYn === 'Y' && vm.allowIpList.length === 0){
        kendo.alert("IP 정책 적용 시 허용 IP를 1개 이상 등록해주세요.")
        vm.errorTarget = null
        return
      }
      vm.errorTarget = null

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/user/createUser.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        cmpyId : cmpyId,
        facilityId: facilityId,
        areaId: areaId,
        authId: authId,
        userId: userId,
        userNm: userNm,
        s1EmpNo: s1EmpNo,
        spTelNo: spTelNo,
        email: email,
        useYn: useYn,
        ipPolicyYn: vm.ipPolicyYn,
        allowIpList: vm.allowIpList,
      }

      ApiUtil.post(url, param).then(response => {
        if(response.data === undefined || response.data.resultStatus === undefined){
          kendo.alert('정상적으로 처리되지 않았습니다.')
          return false
        }

        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          return false
        }

        kendo.alert('사용자가 등록되었습니다.')
        vm.$router.push({
          name: 'UserList'
        })
      })
    },

    onClickList () {
      const vm = this
      vm.$router.push({
        name: 'UserList'
      })
    },

    // ===== IP 접근 제어 설정 =====
    openIpSettings () {
      const vm = this
      vm.$refs.ipSettingsWindowRef.open()
    },

    // 팝업에서 '적용' 시 확정값 반영 (실제 저장은 등록 시점에 수행)
    onApplyIpSettings (payload) {
      const vm = this
      vm.ipPolicyYn = payload.ipPolicyYn
      vm.allowIpList = payload.allowIpList
    },

    // facility 에 따른 area 세팅
    onChangeFacility() {
      const vm = this
      vm.onChange1Depth('facilityRef')
      vm.$refs.areaRef.kendoWidget().setDataSource(vm.zone2DepthListForAll)
    },
  },
  data: function() {
    const vm = this
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }
    let authList = []
    let authCdDtl = this.$store.state.codeRequestStore.search.combobox.authNm.data
    for (let a of authCdDtl) {
      if(a.authId === '1001' || a.authId === '2001' ||a.authId === '9999'){
        authList.push(a)
      }
    }
    // [authList[1], authList[2]] = [authList[2], authList[1]]
    const authByCmpy = [
      {cmpyId: '00001',authId: ['1001','9999']},
      {cmpyId: '00002', authId: ['2001']},
    ]
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      idDuplicateCheck: false,
      idDuplicateId: '',
      selectedAuth: '',
      authNmData : authList,
      authId : '',
      useYn : 99,
      errorTarget : null,
      authByCmpy : authByCmpy,
      // IP 접근 제어 설정 (계정별 정책) — 기본값 미적용('N')
      maxIpCount: 5,
      ipPolicyYn: 'N',
      allowIpList: [],
    }
  }
}
</script>

<style scoped>
.ip-grid {
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 14px;
  row-gap: 2px;
}
.ip-date {
  color: #adb5bd;
}
</style>

